import { usaStates } from "typed-usa-states/dist/states";
export function validateStateFormat(value) {
    if (!value)
        return false;
    return value.length === 2 && /^[a-zA-Z]+$/.test(value);
}
export function validateUsaState(value) {
    return usaStates.some(function (state) { return state.abbreviation.toUpperCase() === (value === null || value === void 0 ? void 0 : value.toUpperCase()); });
}
export function validateZip(value) {
    return (value === null || value === void 0 ? void 0 : value.length) === 5;
}
export function validateNoPoBox(value) {
    var poBoxRegex = /^(?!.*\bP\.?O\.?\s*Box\b).*$/i;
    return poBoxRegex.test(value || "");
}
export function validateUnlinkedApplicantAddress(address) {
    return (Boolean(address.address1) &&
        validateStateFormat(address.state) &&
        validateUsaState(address.state) &&
        validateZip(address.zip));
}
